import { Box, IconButton } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';
import UndoIcon from '../assets/icons/canvasIcons/UndoIcon.svg';
import RedoIcon from '../assets/icons/canvasIcons/RedoIcon.svg';

interface UndoRedoControlsProps {
  isGenerating: boolean;
  handleUndo: () => void;
  handleRedo: () => void;
  flexDirectionType?:string
}

const UndoRedoControls: React.FC<UndoRedoControlsProps> = ({
  isGenerating,
  handleUndo,
  handleRedo,
  flexDirectionType
}) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        right: 10,
        display: 'flex',
        flexDirection: flexDirectionType? flexDirectionType : 'row',
        gap: 2,
        zIndex: 9999
      }}
    >
      <IconButton
        disabled={isGenerating}
        onClick={handleUndo}
        sx={{
          width: 40,
          height: 40,
          backgroundColor: '#111113',
          color: 'white',
          borderRadius: '6px',
          border: `1px solid ${grey[800]}`,
          '&:hover': {
            backgroundColor: grey[700]
          },
          '&:disabled': {
            opacity: 0.5
          }
        }}
      >
        <img src={UndoIcon} alt="undo" className="size-5" />
      </IconButton>
      <IconButton
        onClick={handleRedo}
        disabled={isGenerating}
        sx={{
          width: 40,
          height: 40,
          backgroundColor: '#111113',
          color: 'white',
          borderRadius: '6px',
          border: `1px solid ${grey[800]}`,
          '&:hover': {
            backgroundColor: grey[700]
          },
          '&:disabled': {
            opacity: 0.5
          }
        }}
      >
        <img src={RedoIcon} alt="redo" className="size-5" />
      </IconButton>
    </Box>
  );
};

export default UndoRedoControls;